import { SET_USER_ID } from '../actions/actionTypes'

export default function reducer(state = {}, action)
{
    switch(action.type)
    {
        case SET_USER_ID:
            let stateLocation = action.payload.stateLocation;
            return Object.assign({}, state, {
                [stateLocation]: action.payload.userId
            });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/user/src/reducers/index.js